import * as _ from 'lodash';
import { useMemo } from 'react';
import { IProduct, IContact } from '@nkr/models/index';
import { AgGridReact } from 'ag-grid-react';
import { ColDef, FirstDataRenderedEvent, GridReadyEvent, ICellRendererParams, IHeaderParams } from 'ag-grid-community';
import { GridWrapper } from './styles';
import SortableHeaderComponent from '../../center/list/common/sortable-header';
import { FormControl } from 'react-bootstrap';

interface IProps {
    data: IProduct[],
    staffList: IContact[],
    onGridReady: (e: GridReadyEvent) => void,
    onActiveChange: (productId: number, isActive: number) => void,
    onOwnerChange: (productId: number, owner: string) => void
}

const Grid = (props: IProps) => {
    const onFirstDataRendered = (e: FirstDataRenderedEvent) => {
        e.api.sizeColumnsToFit();
    };

    const columns: ColDef[] = [
        {
            colId: 'name',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Name</SortableHeaderComponent>,
            field: 'name',
            width: 380,
            sortable: true
        },

        {
            colId: 'alias',
            headerComponentFramework: (params: IHeaderParams) =>
                <SortableHeaderComponent {...params}>
                    <div style={{ marginTop: 0 }}>Alias</div>
                </SortableHeaderComponent>,
            field: 'alias',
            width: 280,
            sortable: true
        },

        {
            colId: 'active',
            field: 'isActive',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Is Active</SortableHeaderComponent>,
            width: 100,
            cellRendererFramework: (params: ICellRendererParams) =>
                <FormControl
                    componentClass='select'
                    value={params.data.isActive ? 1 : 0}
                    style={{ padding: '3px 6px', height: 28 }}
                    onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => props.onActiveChange(params.data.id, parseInt(e.currentTarget.value))}
                >
                    <option value={1}>Yes</option>
                    <option value={0}>No</option>
                </FormControl>
        },

        {
            colId: 'owner',
            field: 'owner',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Owner</SortableHeaderComponent>,
            width: 365,
            cellRendererFramework: (params: ICellRendererParams) => {
                return (
                    <FormControl
                        componentClass='select'
                        value={params.data.owner}
                        style={{ padding: '3px 6px', height: 28 }}
                        onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => props.onOwnerChange(params.data.id, e.currentTarget.value)}
                    >
                        <option value={''}>- select an owner -</option>
                        {staffList.map((item, index) =>
                            <option key={index} value={item.abbreviation}>{item.lastName}, {item.firstName}</option>
                        )}
                    </FormControl>
                );
            }
        }
    ];

    const columnDefs = useMemo(() => columns, []);
    const rowData = useMemo(() => props.data, [props.data]);

    const staffList = _.sortBy(props.staffList.filter(x => x.abbreviation != 'M/S'), [(item) => {
        return item.lastName
    }]);

    return (
        <GridWrapper className='ag-theme-bootstrap'>
            <AgGridReact
                columnDefs={columnDefs}
                defaultColDef={{
                    cellClass: 'list-cell',
                    headerClass: 'list-header',
                }}
                rowData={rowData}
                rowHeight={35}
                suppressRowClickSelection={false}
                suppressCellSelection={true}
                noRowsOverlayComponentFramework={() => <div></div>}
                onGridReady={props.onGridReady}
                onFirstDataRendered={onFirstDataRendered}
            />
        </GridWrapper>
    );
}

export default Grid;